export const multiSample = [
  {
    notBaseTopicName: '肿瘤',
    tableRef: [],
    isDelete: 0,
    baseTopicName: '性别',
    id: 43,
    title: '项目参与人完成任务区间分布',
    extTable: {
      summary:
        '行是“药物种类”，列是“医院性质”，表中数据显示了“医院性质”在“药物种类”的数量及其占总体的比例，以及它们各自所占比例,具体数据为:其中“≥20”“药物种类”的“公立医院”占“公立医院”的百分比为58.00%，“＜20”“药物种类”的“公立医院”占“公立医院”的百分比为42.00%，“≥20”“药物种类”的“公立医院”占“≥20”“药物种类”的所有“医院性质”百分比为43.80%，“＜20”“药物种类”的“公立医院”占“＜20”“药物种类”的所有“医院性质”百分比为52.00%，“≥20”“药物种类”的“公立医院”占总计的百分比为27.20%，“＜20”“药物种类”的“公立医院”占总计的百分比为19.70%，“公立医院”的所有“药物种类”占总计的百分比为46.90%；“≥20”“药物种类”的“民营医院”占“民营医院”的百分比为64.90%，“＜20”“药物种类”的“民营医院”占“民营医院”的百分比为35.10%，“≥20”“药物种类”的“民营医院”占“≥20”“药物种类”的所有“医院性质”百分比为53.30%，“＜20”“药物种类”的“民营医院”占“＜20”“药物种类”的所有“医院性质”为百分比47.20%，“≥20”“药物种类”的“民营医院”占总计的百分比为33.10%，“＜20”“药物种类”的“民营医院”占总计的百分比为17.90%，“民营医院”的所有“药物种类”占总计的百分比为51.00%；“≥20”“药物种类”的“其他”占“其他”的百分比为86.40%，“＜20”“药物种类”的“其他”占“其他”的百分比为13.60%，“≥20”“药物种类”的“其他”占“≥20”“药物种类”的所有“医院性质”百分比为2.90%，“＜20”“药物种类”的“其他”占“＜20”“药物种类”的所有“医院性质”百分比为0.80%，“≥20”“药物种类”的“其他”占总计的百分比为1.80%，“＜20”“药物种类”的“其他”占总计的百分比为0.30%，“其他”的所有“药物种类”占总计的百分比为2.10%。',
      header: [
        {
          prop: 'H1',
          label: [''],
          subHeaderList: [
            {
              prop: 'topic',
              label: [''],
              group: true
            },
            {
              prop: 'classify',
              label: [''],
              group: true
            },
            {
              prop: 'item',
              label: ['']
            }
          ]
        },
        {
          prop: 'H2',
          label: ['药物种类'],
          subHeaderList: [
            {
              prop: 'col1',
              label: ['≥20']
            },
            {
              prop: 'col2',
              label: ['<20']
            },
            {
              prop: 'col3',
              label: ['总计']
            }
          ]
        }
      ],
      value: [
        {
          topic: ['医院性质'],
          classify: ['公立医院'],
          item: ['计数'],
          col1: [284],
          col2: [206],
          col3: [490]
        },
        {
          topic: ['医院性质'],
          classify: ['公立医院'],
          item: ['占医院性质的百分比'],
          col1: ['58.0%'],
          col2: ['42.0%'],
          col3: ['100.0%']
        },
        {
          topic: ['医院性质'],
          classify: ['公立医院'],
          item: ['占药物分类的百分比'],
          col1: ['43.8%'],
          col2: ['52.0%'],
          col3: ['46.9%']
        },
        {
          topic: ['医院性质'],
          classify: ['公立医院'],
          item: ['占总计的百分比'],
          col1: ['27.2%'],
          col2: ['19.7%'],
          col3: ['46.9%']
        },

        {
          topic: ['医院性质'],
          classify: ['民营医院'],
          item: ['计数'],
          col1: [346],
          col2: [187],
          col3: [533]
        },
        {
          topic: ['医院性质'],
          classify: ['民营医院'],
          item: ['占医院性质的百分比'],
          col1: ['64.9%'],
          col2: ['35.1%'],
          col3: ['100.0%']
        },
        {
          topic: ['医院性质'],
          classify: ['民营医院'],
          item: ['占药物分类的百分比'],
          col1: ['53.3%'],
          col2: ['47.2%'],
          col3: ['51.0%']
        },
        {
          topic: ['医院性质'],
          classify: ['民营医院'],
          item: ['占总计的百分比'],
          col1: ['33.1%'],
          col2: ['17.9%'],
          col3: ['51.0%']
        },

        {
          topic: ['医院性质'],
          classify: ['其它'],
          item: ['计数'],
          col1: [19],
          col2: [3],
          col3: [22]
        },
        {
          topic: ['医院性质'],
          classify: ['其它'],
          item: ['占医院性质的百分比'],
          col1: ['86.4%'],
          col2: ['13.6%'],
          col3: ['100.0%']
        },
        {
          topic: ['医院性质'],
          classify: ['其它'],
          item: ['占药物分类的百分比'],
          col1: ['2.9%'],
          col2: ['0.8%'],
          col3: ['2.1%']
        },
        {
          topic: ['医院性质'],
          classify: ['其它'],
          item: ['占总计的百分比'],
          col1: ['1.8%'],
          col2: ['0.3%'],
          col3: ['2.1%']
        },

        {
          topic: ['总计'],
          classify: [''],
          item: ['计数'],
          col1: [649],
          col2: [396],
          col3: [1045]
        },
        {
          topic: ['总计'],
          classify: [''],
          item: ['占医院性质的百分比'],
          col1: ['62.1%'],
          col2: ['37.9%'],
          col3: ['100.0%']
        },
        {
          topic: ['总计'],
          classify: [''],
          item: ['占药物分类的百分比'],
          col1: ['100.0%'],
          col2: ['100.0%'],
          col3: ['100.0%']
        },
        {
          topic: ['总计'],
          classify: [''],
          item: ['占总计的百分比'],
          col1: ['62.1%'],
          col2: ['37.9%'],
          col3: ['100.0%']
        }
      ].map(item => {
        ['col1', 'col2', 'col3'].forEach(key => {
          if (typeof item[key][0] === 'string') {
            item[key] = [parseFloat(item[key][0]).toFixed(2) + '%'];
          }
        });
        return item;
      })
    },
    table: {
      header: [
        { prop: 'numRange', label: ['分类指标'] },
        { prop: 'peopleNum', label: ['≥20种'] },
        { prop: 'rate', label: ['<20种'] }
      ],
      value: [
        {
          numRange: ['公立医院'],
          peopleNum: ['284'],
          rate: ['206']
        },
        {
          numRange: ['民营医院'],
          peopleNum: ['346'],
          rate: ['187']
        },
        {
          numRange: ['其他'],
          peopleNum: ['19'],
          rate: ['3']
        }
      ]
    }
  }
];
